import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import externalApiService from "../../../services/externalApiService";
import useApi from "../../../hooks/useApi";
import EntityContext from "../../../context/entityContext";
import dateParser from "../../../utils/DateParser";

const ClientCompanyReview = () => {


    const { ParseDateDMY } = dateParser();

    const { entityDetails  } = useContext(EntityContext);
    
    const fetchStatusApi = useApi(externalApiService.getHubspotCompanyReviewStatus);

    const [reviewData, setReviewData] = useState(null);
    const [isPrimary, setIsPrimary] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchReviewStatus = async () => {
        try {
            const response = await fetchStatusApi.request();
            if (response.data.success) {
                setIsPrimary(response.data.is_primary);
                setReviewData(response.data.data); // your JSON's `data` object
            } else {
                setError(response.data.message || "Unable to fetch review status");
            }
        } catch (err) {
            setError("Something went wrong while fetching review status");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReviewStatus();
    }, []);

    // Helper: decide if form should be shown
    const shouldShowForm = (data) => {
        if (!data) return false;

        const { cadence_date, company_review_documents_status } = data;
        console.log(company_review_documents_status); 
        if (!cadence_date || !company_review_documents_status) return false;

        const cadenceDate = new Date(cadence_date);
        const today = new Date();

        const MS_PER_DAY = 24 * 60 * 60 * 1000;
        const daysUntilReview = Math.floor((cadenceDate - today) / MS_PER_DAY);

        // Starting 30 days before the review date (and onwards) while status is Pending
        return company_review_documents_status != "Submitted" && daysUntilReview <= 30;
    };

    const getComplianceStatus = (compliance_review_pass) => {
      if (compliance_review_pass == 'true') return "Pass";
      if (compliance_review_pass == 'false') return "Fail";
      return "In Progress";
    };

    const getReviewStatus = (company_review_documents_status) => {
      if (company_review_documents_status === 'Submitted - Under Review') return "Submitted - Under Review";
      if (company_review_documents_status === 'Submitted') return "Submitted - Complete";
      return "Submission Pending";
    };

  const showForm = shouldShowForm(reviewData);

  // Load HubSpot form script only when we actually need to show the form
  useEffect(() => {
      if (!showForm) return;

      // Avoid loading the script multiple times
      if (window.hbspt && window.hbspt.forms) {
        
        window.hbspt.forms.create({
          region: "na1",
          portalId: "5367608",
          formId: "33021647-2518-4af4-aabd-bcc879165f7d",
          target: "#hubspot-review-form",
        });

        return;
      }


      const script = document.createElement("script");
      script.src = `https://js.hsforms.net/forms/v2.js`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        
        if (!window.hbspt || !window.hbspt.forms) return;

       

        window.hbspt.forms.create({
          region: "na1",
          portalId: "5367608",
          formId: "33021647-2518-4af4-aabd-bcc879165f7d",
          target: "#hubspot-review-form",
        });
      };

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }, [showForm, reviewData, entityDetails]);


  const renderContent = () => {
    if (loading) {
      return (
            <div className="col-lg-12">
              <div className="card shadow-sm">
                <div className="card-body text-center py-5">
                  <p className="text-muted mb-0">Loading review form...</p>
                </div>
              </div>
            </div>
      );
    }

     if (!isPrimary) {
      return (
            
              <div className="">
                <div className="text-center py-5">
                  <span className="text-danger font-weight-bold mb-0">You do not have the required permissions to perform this action!</span>
                </div>
              </div>
          
      );
    }

    if (error) {
      return (
        <div className="col-lg-12">
            <div className="alert alert-danger shadow-sm" role="alert">
              <div className="d-flex align-items-start">
                <div className="flex-grow-1">
                  <h5 className="alert-heading mb-2">Error Loading Review Form</h5>
                  <p className="mb-3">{error}</p>
                  <button
                    onClick={() => {
                      setError(null);
                      setLoading(true);
                      fetchReviewStatus();
                    }}
                    className="btn btn-danger"
                  >
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          </div>
      );
    }

    if (!reviewData) {
      return <p>No review data available.</p>;
    }

    const { cadence_date, company_review_documents_status, cadence_date_plus_6_months, compliance_review_pass } = reviewData;
    
    // 1) Show review form (within 30 days and Pending)
    // if (showForm) {
    //   return <div id="hubspot-review-form" />;
    // }

    // 2) If Pending but outside 30-day window → show next review date
    if (company_review_documents_status === "Pending" && !showForm) {
      return (
        <div className="card bg-light border-0 mb-3">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-8">
                <div className="d-flex align-items-center">
                  <div>
                    <p className="text-muted small mb-1">Next Review Date</p>
                    <h6 className="mb-0">{cadence_date ? ParseDateDMY(cadence_date) : 'N/A'}</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-4 text-md-end mt-3 mt-md-0">
                <p className="text-muted small mb-1">Review Status</p>
                {getReviewStatus(company_review_documents_status)}
              </div>
            </div>
          </div>
        </div>

      );
    }

    if(company_review_documents_status !== 'Submitted' && showForm){
      return (
        <div className="row g-3">
            <div className="col-md-6">
              <div className="card bg-light border-0 h-100">
                <div className="card-body">
                  <p className="text-muted small mb-2">Review Status</p>
                  {getReviewStatus(company_review_documents_status)}
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card bg-light border-0 h-100">
                <div className="card-body">
                  <p className="text-muted small mb-2">Review Date</p>
                  <h6 className="mb-0">{cadence_date ? ParseDateDMY(cadence_date) : 'N/A'}</h6>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              {showForm && <div id="hubspot-review-form" />}
            </div>

        </div>
      );
    }

    // 3) Else show the status
    return (
        <div className="row g-3">
          <div className="col-md-6">
            <div className="card bg-light border-0 h-100">
              <div className="card-body">
                <p className="text-muted small mb-2">Review Status</p>
                {getReviewStatus(company_review_documents_status)}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card bg-light border-0 h-100">
              <div className="card-body">
                <p className="text-muted small mb-2">Review Date</p>
                <h6 className="mb-0">{cadence_date ? ParseDateDMY(cadence_date) : 'N/A'}</h6>
              </div>
            </div>
          </div>

          <div className="col-md-6 mt-2">
            <div className="card bg-light border-0 h-100">
              <div className="card-body">
                <p className="text-muted small mb-2">Compliance Outcome</p>
                {getComplianceStatus(compliance_review_pass)}
              </div>
            </div>
          </div>

          <div className="col-md-6 mt-2">
            <div className="card bg-light border-0 h-100">
              <div className="card-body">
                <p className="text-muted small mb-2">Next Review Date</p>
                <h6 className="mb-0">{cadence_date_plus_6_months ? ParseDateDMY(cadence_date_plus_6_months) : 'N/A'}</h6>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
        <>
        <Helmet>
            <title>Renewal & Company Reviews| {global.config.title}</title>
        </Helmet>
        <div className="col-lg-12 m-auto card">
            <div className="card-body">
              <h6>Renewal & Company Reviews</h6>
                {renderContent()}
            </div>
        </div>
        </>
    );
};

export default ClientCompanyReview;
